import { Theme } from '@mui/material';

export const sxStyles = {
  relatedCertificationsTitle: (theme: Theme) => ({
    color: theme.palette.primary.main,
    marginBottom: '2rem',
  }),
  showBtnWrap: {
    display: 'flex',
    justifyContent: 'center',
  },
  showBtn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

    '&:hover': {
      cursor: 'pointer',
    },
  },
  showTextBtn: (theme: Theme) => ({
    margin: '0.75rem 0',
    color: theme.palette.primary.main,
    fontWeight: 600,
    fontSize: '1rem',
  }),
};
